var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 25,
    viewBox: "0 0 55 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L1.80303 2.44769C2.60606 3.89538 4.21212 6.79075 5.81818 9.06767C7.42424 11.3446 9.0303 13.003 10.6364 13.8984C12.2424 14.7937 13.8485 14.926 15.4545 13.63C17.0606 12.334 18.6667 9.60971 20.2727 10.2569C21.8788 10.9042 23.4848 14.9229 25.0909 16.7854C26.697 18.6479 28.303 18.3542 29.9091 17.1856C31.5152 16.0169 33.1212 13.9733 34.7273 11.7995C36.3333 9.62577 37.9394 7.32186 39.5455 8.00815C41.1515 8.69443 42.7576 12.3709 44.3636 13.2084C45.9697 14.046 47.5758 12.0445 49.1818 13.3699C50.7879 14.6953 52.3939 19.3477 53.197 21.6738L54 24",
    stroke: "#C60F0F",
    strokeOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphDown);
export default __webpack_public_path__ + "static/media/graph_down.94965e466dab53d35390c521b593b3f9.svg";
export { ForwardRef as ReactComponent };